export enum PlaceholderStatus {
  Active = 'ACTIVE',
  CheckActive = 'CHECK_ACTIVE',
  Inactive = 'INACTIVE',
}
